module.exports = __webpack_public_path__ + "img/mediagate-logo.394d0451.svg";